export enum FlagColor {
    None = -1,
    Red= 0 ,
    Orange = 1,
    Yellow = 2,
    Green = 3,
    Blue = 4,
    Purple = 5
}
